import React, { useState, useEffect } from "react";
import ApiService from "../../../services/Api.service";
import ToggleSwitch from "../../ToggelSwitch/ToggelSwitch";
import Button from "../../Button/Button";
import Dropdown from "../../Dropdown/Dropdown";
import Modal from "../../Modal/Modal";
import "../AddSectionModal/AddSectionModal.css";

const DEFAULT_TEMPLATE_TYPES = [
  { value: "Automatic", label: "Automatic" },
  { value: "Approval", label: "Approval" },
];

const SaveAsTemplateModal = ({
  onClose,
  onSave,
  initialName = "",
  initialType = "Automatic",
  templateError,
  sharedWith,
  initialRealtime = false,
  isRealTimeTranscriptionFeature = false,
}) => {
  const [templateName, setTemplateName] = useState(initialName);
  const [templateType, setTemplateType] = useState(initialType || "Automatic");
  const [templateTypes, setTemplateTypes] = useState(DEFAULT_TEMPLATE_TYPES);
  const [realtimeEnabled, setRealtimeEnabled] = useState(initialRealtime);

  const fetchDetails = async () => {
    try {
      let processRes = await ApiService.getProcessTypes();
      if (processRes?.status === 200 && Array.isArray(processRes.data?.process_type) && processRes.data.process_type.length > 0) {
        setTemplateTypes(processRes.data.process_type);
      }
    } catch (error) {
      console.warn("Using default process types:", error);
    }
  };

  useEffect(() => {
    fetchDetails();
  }, []);

  useEffect(() => {
    setTemplateName(initialName);
    setTemplateType(initialType || "Automatic");
    setRealtimeEnabled(initialRealtime);
  }, [initialName, initialType, initialRealtime]);

  const handleSave = () => {
    if (templateName.trim() === "") return;
    onSave({
      name: templateName,
      process_type: templateType,
      shared_with: sharedWith || [],
      is_real_time_transcription: realtimeEnabled,
    });
  };

  const footer = (
    <>
      <Button variant="outline" onClick={onClose}>
        Cancel
      </Button>
      <Button variant="primary" onClick={handleSave}>
        Save
      </Button>
    </>
  );

  return (
    <Modal
      isOpen={true}
      onClose={onClose}
      title="Save Template"
      maxWidth="560px"
      footer={footer}
    >
      <div className="section-modal-form-group">
        <label className="section-modal-label">Template Name</label>
        <input
          type="text"
          value={templateName}
          onChange={(e) => setTemplateName(e.target.value)}
          placeholder="Enter template name"
          className="form-control"
        />
        {templateError && <p className="section-modal-error">{templateError}</p>}
      </div>

      <div className="section-modal-form-group">
        <label className="section-modal-label">Template Type</label>
        <Dropdown
          name="templateType"
          id="templateType"
          placeholder="Select Template Type"
          value={templateType}
          onChange={(e) => setTemplateType(e.target.value)}
          options={templateTypes}
        />
        {templateType === "Approval" && (
          <p className="delete-confirm-prompt">
            Requires approval before the template can be used for audits.
          </p>
        )}
      </div>

      {isRealTimeTranscriptionFeature && (
        <div className="section-modal-form-group">
          <ToggleSwitch
            label="Enable Real-time Transcription"
            checked={realtimeEnabled}
            onChange={setRealtimeEnabled}
          />
        </div>
      )}
    </Modal>
  );
};

export default SaveAsTemplateModal;